import { render, staticRenderFns } from "./GoodsSendBackDetail.vue?vue&type=template&id=d2fb89f4&scoped=true&"
import script from "./GoodsSendBackDetail.vue?vue&type=script&lang=js&"
export * from "./GoodsSendBackDetail.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSendBackDetail.vue?vue&type=style&index=0&id=d2fb89f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2fb89f4",
  null
  
)

export default component.exports